import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { message } from "antd";
import { createRoom, deleteRoom, fetchAllRooms, fetchRooms, statusRoomToggle, updateRoom } from "../../../service/api";


export const getRooms = createAsyncThunk(
    "rooms/getAll",
    async (params, { rejectWithValue }) => {
        try {
            const response = await fetchRooms(params)
            console.log("rooms", response)
            return response.data.data
        } catch (error) {
            return rejectWithValue(err.response?.data || err.message)
        }
    }
)


export const getAllRooms = createAsyncThunk(
    "allrooms/getAll",
    async (params, { rejectWithValue }) => {
        try {
            const response = await fetchAllRooms(params)
            console.log("all rooms", response)
            return response.data
        } catch (error) {
            return rejectWithValue(err.response?.data || err.message)
        }
    }
)

export const deleteRooms = createAsyncThunk(
    "rooms/delete",
    async (formValue, { rejectWithValue }) => {
        try {
            const response = await deleteRoom(formValue)
            if (response.status === 201) {
                console.log("delete", response)
            }
        } catch (error) {
            return rejectWithValue(error.response || error)
        }
    }
)


export const roomStatus = createAsyncThunk(
    "rooms/status",
    async (formValue, { rejectWithValue }) => {
        try {
            const response = await statusRoomToggle(formValue)
            if (response.status === 201) {
                console.log("delete", response)
            }
        } catch (error) {
            return rejectWithValue(error.response || error)
        }
    }
)

export const addRooms = createAsyncThunk(
    "rooms/add",
    async (formValue, { rejectWithValue }) => {
        try {
            const response = await createRoom(formValue)
            if (response.status === 201) {
                console.log("response", response)
            }
        } catch (error) {
            return rejectWithValue(error.response || error)
        }
    }
)
export const editRooms = createAsyncThunk(
    "rooms/edit",
    async (newData, { rejectWithValue }) => {
        try {
            const response = await updateRoom(newData)
            if (response.status === 201) {
                console.log("edit room", response)
            }
        } catch (error) {
            console.log(error)
            return rejectWithValue(error.response.data || error.message)
        }
    }
)



const roomSlice = createSlice({
    name: "rooms",
    initialState: {
        roomList: [],
        allRoomList: [],
        isLoading: false,
        actionLoader: false,
        error: null,
        totalPage: 0,
        current: 1,
        limit: 10,
        searchParams: ""
    },
    reducers: {
        setPagination: (state, action) => {
            state.current = action.payload;
        },
        setSearchParams: (state, action) => {
            state.searchParams = action.payload;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getRooms.pending, (state) => {
                state.isLoading = true,
                    state.error = null
            })
            .addCase(getRooms.fulfilled, (state, action) => {
                state.isLoading = false;
                state.roomList = action.payload.data;
                state.totalPage = action.payload.totalPages
            })
            .addCase(getRooms.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload
            })

            // all rooms 

            .addCase(getAllRooms.pending, (state) => {
                state.isLoading = true,
                    state.error = null
            })
            .addCase(getAllRooms.fulfilled, (state, action) => {
                state.isLoading = false;
                state.allRoomList = action.payload.data;
            })
            .addCase(getAllRooms.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload
            })

            // POST
            .addCase(addRooms.pending, (state, action) => {
                state.actionLoader = true;
            })
            .addCase(addRooms.fulfilled, (state, action) => {
                state.actionLoader = false;
            })
            .addCase(addRooms.rejected, (state, action) => {
                state.actionLoader = false;
                state.error = action.payload;
            })

            // PUT
            .addCase(editRooms.pending, (state, action) => {
                state.actionLoader = true;
            })
            .addCase(editRooms.fulfilled, (state, action) => {
                state.actionLoader = false;
            })
            .addCase(editRooms.rejected, (state, action) => {
                state.actionLoader = false;
                state.error = action.payload;
            })


            // PUT Status
            .addCase(roomStatus.pending, (state, action) => {
                state.actionLoader = true;
            })
            .addCase(roomStatus.fulfilled, (state, action) => {
                state.actionLoader = false;
            })
            .addCase(roomStatus.rejected, (state, action) => {
                state.actionLoader = false;
                state.error = action.payload;
            })

            // delete
            .addCase(deleteRooms.pending, (state, action) => {
                state.actionLoader = true;
            })
            .addCase(deleteRooms.fulfilled, (state, action) => {
                state.actionLoader = false;
            })
            .addCase(deleteRooms.rejected, (state, action) => {
                state.actionLoader = false;
                state.error = action.payload;
            })
    }
})
export const { setSearchParams, setPagination } = roomSlice.actions;

export default roomSlice.reducer;